/* WightMade3D Etsy-style feed: loads the next page of the More to explore grid as you scroll. */
(function () {
  function bind(root) {
    if (!root || !root.querySelector) return;
    var box = root.querySelector('[data-wm3d-more]');
    var grid = root.querySelector('[data-wm3d-more-grid]');
    if (!box || !grid || box.getAttribute('data-bound') === 'true') return;
    box.setAttribute('data-bound', 'true');
    var link = box.querySelector('a');
    var busy = false;
    var failed = false;
    var observer = null;

    function nearViewport() {
      return box.isConnected && box.getBoundingClientRect().top < window.innerHeight + 900;
    }

    function load() {
      var next = box.getAttribute('data-next-url');
      if (busy || !next) return;
      busy = true;
      box.classList.add('is-loading');
      var url = next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(box.getAttribute('data-section-id'));
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('[data-wm3d-more-grid]');
          if (incoming) {
            Array.prototype.slice.call(incoming.children).forEach(function (item) {
              grid.appendChild(document.importNode(item, true));
            });
          }
          var nextBox = doc.querySelector('[data-wm3d-more]');
          var nextUrl = nextBox ? nextBox.getAttribute('data-next-url') : '';
          if (nextUrl) {
            box.setAttribute('data-next-url', nextUrl);
            if (link) link.setAttribute('href', nextUrl);
          } else {
            box.removeAttribute('data-next-url');
            if (observer) observer.disconnect();
            box.remove();
          }
        })
        .catch(function () { failed = true; })
        .then(function () {
          busy = false;
          box.classList.remove('is-loading');
          if (!failed && box.getAttribute('data-next-url') && nearViewport()) window.setTimeout(load, 100);
        });
    }

    if (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        failed = false;
        load();
      });
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !failed) load();
      }, { rootMargin: '0px 0px 900px 0px' });
      observer.observe(box);
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.wm3d-feed'), bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
})();
